module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00067.759bf7b5.jpg";